// import React from "react";

// export default function Careers() {
//   return (
//     <main id="content" className="content">
//       <section
//         className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150"
//         style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
//         data-parallax="true"
//         data-parallax-options={{ parallaxBG: true }}
//       >
//         <div className="container">
//           <div className="row">
//             <div className="lqd-column col-md-6">
//               <h1 className="text-white pr-md-5 mt-0 mb-40">
//                 Careers - Document Collection Job - Docboyz
//               </h1>
//               <p className="text-white font-size-16 lh-185 pr-md-7 mb-60">
//               <h1 style={{ fontSize: '2em' }}>
//       <span style={{ color: 'white' }}>Join the </span>
//       <span style={{ color: 'red' }}>DocBoyz Family!</span>
//     </h1>
//                Join the DocBoyz Family! Since our inception in 2018, DocBoyz has been on a mission to revolutionize the fragmented Fintech logistics landscape in India, previously dominated by small local agencies. Our vision? To bring order to this chaos by harnessing cutting-edge technology and empowering stakeholders in the collection services for Banks and NBFCs.

//               </p>
//               <p className="text-white font-size-16 lh-185 pr-md-7 mb-60">
              
//                 At the heart of our innovation lies a "phygital" platform, seamlessly integrating technology with a robust human network. We take pride in transforming traditional methods of document collection, customer verification, and debt recovery, paving the way for a new era in Fintech logistics. Our mission is clear: to defragment and democratize this vital sector.

//               </p>
//               <p className="text-white font-size-16 lh-185 pr-md-7 mb-60"> 
//                  We invite dynamic individuals eager to embrace challenges and discover uncharted territories to join us. The start-up journey at DocBoyz offers invaluable insights and entrepreneurial exposure, fostering growth for every team member. Let’s shape the future together!

//               </p>
//             </div>
//             <div className="lqd-column col-md-6">
//               <form className="contact-form">
//                 <h3 className="text-white mb-30">Apply Here</h3>
//                 <div className="form-group">
//                   <label htmlFor="fullName" className="text-white">Full Name*</label>
//                   <input type="text" id="fullName" className="form-control" placeholder="Enter your full name" required />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="email" className="text-white">Email ID*</label>
//                   <input type="email" id="email" className="form-control" placeholder="Enter your email" required />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="phone" className="text-white">Phone*</label>
//                   <input type="tel" id="phone" className="form-control" placeholder="Enter your phone number" required />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="dob" className="text-white">D.O.B*</label>
//                   <input type="date" id="dob" className="form-control" required />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="qualification" className="text-white">Qualification</label>
//                   <input type="text" id="qualification" className="form-control" placeholder="Enter your qualification" />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="resume" className="text-white">Attach Resume Here*</label>
//                   <input type="file" id="resume" className="form-control" required />
//                 </div>
//                 <button type="submit" className="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient px-2">
//                   Submit Application
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Latest Job Openings Section */}
//       <section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
//         <div className="container">
//           <div className="row">
//             <div className="lqd-column col-md-12">
//               <h2 className="mb-30">Latest Job Openings</h2>
//               <p>
//                 <strong>1. Fintech Correspondents</strong><br />
//                 We are looking for Fintech Correspondents in Hyderabad, Telangana.<br />
//                 <strong>Job Description:</strong> Document collection and verification for Banks and NBFCs.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }


import React from "react";
import 'normalize.css';


export default function Careers() {
  return (
    <main id="content" className="content">
      <section
        className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150"
        style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
        data-parallax="true"
        data-parallax-options={{ parallaxBG: true }}
      >
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-6">
              <h1 className="text-white pr-md-5 mt-0 mb-40">
                Careers - Document Collection Job - Docboyz
              </h1>
              <h1 style={{ fontSize: '2em' }}>
                <span style={{ color: 'white' }}>Join the </span>
                <span style={{ color: 'red' }}>DocBoyz Family!</span>
              </h1>
              <p className="text-white font-size-16 lh-185 pr-md-7 mb-60">
                Since our inception in 2018, DocBoyz has been on a mission to revolutionize the fragmented Fintech logistics landscape in India, previously dominated by small local agencies. Our vision? To bring order to this chaos by harnessing cutting-edge technology and empowering stakeholders in the collection services for Banks and NBFCs.
              </p>
              <p className="text-white font-size-16 lh-185 pr-md-7 mb-60">
                At the heart of our innovation lies a "phygital" platform, seamlessly integrating technology with a robust human network. We take pride in transforming traditional methods of document collection, customer verification, and debt recovery, paving the way for a new era in Fintech logistics. Our mission is clear: to defragment and democratize this vital sector.
              </p>
              <p className="text-white font-size-16 lh-185 pr-md-7 mb-60">
                We invite dynamic individuals eager to embrace challenges and discover uncharted territories to join us. The start-up journey at DocBoyz offers invaluable insights and entrepreneurial exposure, fostering growth for every team member. Let’s shape the future together!
              </p>
            </div>
            <div className="lqd-column col-md-6">
              <form className="contact-form">
                <h3 className="text-white mb-30">Apply Here</h3>
                <div className="form-group">
                  <label htmlFor="fullName" className="text-white">Full Name*</label>
                  <input type="text" id="fullName" className="form-control" placeholder="Enter your full name" required />
                </div>
                <div className="form-group">
                  <label htmlFor="email" className="text-white">Email ID*</label>
                  <input type="email" id="email" className="form-control" placeholder="Enter your email" required />
                </div>
                <div className="form-group">
                  <label htmlFor="phone" className="text-white">Phone*</label>
                  <input type="tel" id="phone" className="form-control" placeholder="Enter your phone number" required />
                </div>
                <div className="form-group">
                  <label htmlFor="dob" className="text-white">D.O.B*</label>
                  <input type="date" id="dob" className="form-control" required />
                </div>
                <div className="form-group">
                  <label htmlFor="qualification" className="text-white">Qualification</label>
                  <input type="text" id="qualification" className="form-control" placeholder="Enter your qualification" />
                </div>
                <div className="form-group">
                  <label htmlFor="resume" className="text-white">Attach Resume Here*</label>
                  <input type="file" id="resume" className="form-control" required />
                </div>
                <button type="submit" className="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient px-2">
                  Submit Application
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Job Openings Section */}
      <section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-6">
              <h2 className="mb-30">Latest Job Openings</h2>
              <p>
                <strong>1. Fintech Correspondents</strong><br />
                We are looking for Fintech Correspondents in Hyderabad, Telangana.<br />
                <strong>Job Description:</strong> Document collection and verification for Banks and NBFCs.
              </p>
            </div>
            {/* my-app\public\assets\img\Carees\Team01.jpeg */}
            <div className="lqd-column col-md-6">
              <img
                src="assets/img/Carees/Team01.jpg"
                alt="Job Opportunities at DocBoyz"
                style={{ width: '100%', borderRadius: '8px' }}
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
